import React, {Component} from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import DashboardTile from '../../../../presentation/DashboardTile';

class SipDashboards extends Component {
  constructor() {
    super();

    this.interval = 0;

    this.categoryOptions = [
      { value: 0, text: 'Recognizer Errrors - Hourly'},
      { value: 1, text: 'Recognizer Errrors - Daily' },
      { value: 2, text: 'Recognizer Errrors - Weekly' },
      { value: 3, text: 'Recognizer Errrors - Monthly' },
      { value: 4, text: 'Recognizer Errrors - Yearly' },
    ];

    this.SITE_DEFAULT_STATS = [
      { normal: 5,warning: 6, alert: 12 },
      { normal: 120,warning: 121, alert: 240 },
      { normal: 840,warning: 841, alert: 1680 },
      { normal: 3600,warning: 3601, alert: 7200 },
      { normal: 43800,warning: 43801, alert: 87600 }
    ];

    this.MEDIA_DEFAULT_STATS = [
      { normal: 2, warning: 3, alert: 6 },
      { normal: 48, warning: 49, alert: 96 },
      { normal: 336, warning: 337, alert: 672 },
      { normal: 1440, warning: 1441, alert: 2880 },
      { normal: 17520, warning: 17520, alert: 35040 }
    ];

    this.DASHBOARDS = {
      RECOGNIZER_ERRORS_HOURLY_DASHBOARD: 0,
      RECOGNIZER_ERRORS_DAILY_DASHBOARD: 1,
      RECOGNIZER_ERRORS_WEEKLY_DASHBOARD: 2,
      RECOGNIZER_ERRORS_MONTHLY_DASHBOARD: 3,
      RECOGNIZER_ERRORS_YEARLY_DASHBOARD: 4
    };

    this.state = {
      category: 0,
      data: []
    };

    // Bound Events
    this.onCategoryChange = this.onCategoryChange.bind( this );
  }

  onCategoryChange( e ) {
    this.setState( { 
      category: e.target.value
    } );
  }
  
  onRenderFilters() {
    const categoryOptions = this.categoryOptions;
    const options = [];
    if( categoryOptions !== undefined ) {
      if( categoryOptions.length > 0 ) {
        for( var index = 0; index < categoryOptions.length; index++ ) {
          const category = categoryOptions[ index ];
          options.push(
            <option key={'category-option-' + index.toString()} value={category.value}>
              {category.text}
            </option>
          )      
        }
      }
    }
    return (
      <div className="sip-dashboards-filter-field">
        <span>Category</span>
        <select value={this.state.category} onChange={this.onCategoryChange}>
          {options}
        </select>
      </div>
    );
  }

  onRenderDashboards() {
    const category = parseInt( this.state.category, 10 );
    if( category === this.DASHBOARDS.RECOGNIZER_ERRORS_HOURLY_DASHBOARD ) {
        return this.onRenderRecognizerErrorsHourlyDashboard();
    } else if( category === this.DASHBOARDS.RECOGNIZER_ERRORS_DAILY_DASHBOARD ) {
      return this.onRenderRecognizerErrorsDailyDashboard();
    } else if( category === this.DASHBOARDS.RECOGNIZER_ERRORS_MONTHLY_DASHBOARD ) {
        return this.onRenderRecognizerErrorsMonthlyDashboard();
    } else if( category === this.DASHBOARDS.RECOGNIZER_ERRORS_WEEKLY_DASHBOARD ) {
      return this.onRenderRecognizerErrorsWeeklyDashboard();
    } else if( category === this.DASHBOARDS.RECOGNIZER_ERRORS_YEARLY_DASHBOARD ) {
      return this.onRenderRecognizerErrorsYearlyDashboard();
    } else {
        return '';
    }
  }

  onRenderRecognizerErrorsHourlyDashboard( ) {
    const renderedControls = [];
    const category = this.state.category;
    const site_normal = this.SITE_DEFAULT_STATS[category].normal;
    const site_warning = this.SITE_DEFAULT_STATS[category].warning;
    const site_alert = this.SITE_DEFAULT_STATS[category].normal;
    const media_normal = this.MEDIA_DEFAULT_STATS[category].normal;
    const media_warning = this.MEDIA_DEFAULT_STATS[category].warning;
    const media_alert = this.MEDIA_DEFAULT_STATS[category].normal;

    renderedControls.push(
      <div key="sip-dashboards-content-caption-hourly-1" className="sip-dashboards-content-caption">
        <span>Sites Hourly Totals</span>
      </div>
    );

    // Florida/New York Sites
    renderedControls.push(
      <div key="sip-dashboards-content-row-hourly-1" className="sip-dashboards-content-row">
        <DashboardTile
          caption="SITE: Florida"
          duration="1H"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
        <DashboardTile
          caption="SITE: New York"
          duration="1H"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
      </div>
    );

    renderedControls.push(
      <div key="sip-dashboards-content-caption-hourly-2" className="sip-dashboards-content-caption">
        <span>Florida Media Hourly Totals</span>
      </div>
    );

    // Florida Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-hourly-row-2" className="sip-dashboards-content-row">            
        <DashboardTile
            caption="FLMedia1"
            duration="1H"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/lasthour'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"Florida"},{"NODE":"101"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="FLMedia2"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"102"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia3"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"103"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia4"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"104"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia5"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"105"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia6"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"106"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia7"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"107"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia8"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"108"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia9"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"109"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"110"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>          
    );

    renderedControls.push(
      <div key="sip-dashboards-content-caption-hourly-3" className="sip-dashboards-content-caption">
        <span>New York Media Hourly Totals</span>
      </div>
    );

    // New York Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-hourly-row-3" className="sip-dashboards-content-row">
        <DashboardTile
            caption="NYMedia1"
            duration="1H"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/lasthour'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"New York"},{"NODE":"201"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="NYMedia2"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"202"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia3"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"203"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia4"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"204"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia5"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"205"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia6"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"206"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia7"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"207"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia8"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"208"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia9"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"209"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia10"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"210"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia11"
          duration="1H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/lasthour'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"211"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>
    );
    
    return renderedControls;
  }

  onRenderRecognizerErrorsDailyDashboard( ) {
    const renderedControls = [];
    const category = this.state.category;
    const site_normal = this.SITE_DEFAULT_STATS[category].normal;
    const site_warning = this.SITE_DEFAULT_STATS[category].warning;
    const site_alert = this.SITE_DEFAULT_STATS[category].normal;
    const media_normal = this.MEDIA_DEFAULT_STATS[category].normal;
    const media_warning = this.MEDIA_DEFAULT_STATS[category].warning;
    const media_alert = this.MEDIA_DEFAULT_STATS[category].normal;

    renderedControls.push(
      <div key="sip-dashboards-content-caption-daily-1" className="sip-dashboards-content-caption">
        <span>Sites Daily Totals</span>
      </div>
    );

     // Florida/New York Sites
     renderedControls.push(
      <div key="sip-dashboards-content-daily-row-1" className="sip-dashboards-content-row">
        <DashboardTile
          caption="SITE: Florida"
          duration="24H"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}          
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
        <DashboardTile
          caption="SITE: New York"
          duration="24H"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
      </div>
    );

    renderedControls.push(
      <div key="sip-dashboards-content-caption-daily-2" className="sip-dashboards-content-caption">
        <span>Florida Media Daily Totals</span>
      </div>
    );
      
    // Florida Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-daily-row-2" className="sip-dashboards-content-row">            
        <DashboardTile
            caption="FLMedia1"
            duration="24H"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/daily'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"Florida"},{"NODE":"101"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="FLMedia2"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"102"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia3"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"103"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia4"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"104"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia5"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"105"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia6"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"106"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia7"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"107"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia8"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"108"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia9"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"109"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"110"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>          
    );

    renderedControls.push(
      <div key="sip-dashboards-content-caption-daily-3" className="sip-dashboards-content-caption">
        <span>New York Media Daily Totals</span>
      </div>
    );

    // New York Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-row-3" className="sip-dashboards-content-row">
        <DashboardTile
            caption="NYMedia1"
            duration="24H"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}            
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/daily'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"New York"},{"NODE":"201"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="NYMedia2"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}          
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"202"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia3"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"203"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia4"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"204"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia5"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"205"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia6"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"206"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia7"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"207"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia8"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"208"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia9"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"209"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"210"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia11"
          duration="24H"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/daily'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"211"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>
    );

    return renderedControls;
  }

  onRenderRecognizerErrorsWeeklyDashboard( ) {
    const renderedControls = [];
    const category = this.state.category;
    const site_normal = this.SITE_DEFAULT_STATS[category].normal;
    const site_warning = this.SITE_DEFAULT_STATS[category].warning;
    const site_alert = this.SITE_DEFAULT_STATS[category].normal;
    const media_normal = this.MEDIA_DEFAULT_STATS[category].normal;
    const media_warning = this.MEDIA_DEFAULT_STATS[category].warning;
    const media_alert = this.MEDIA_DEFAULT_STATS[category].normal;


    renderedControls.push(
      <div key="sip-dashboards-content-caption-weekly-1" className="sip-dashboards-content-caption">
        <span>Sites Weekly Totals</span>
      </div>
    );

     // Florida/New York Sites
     renderedControls.push(
      <div key="sip-dashboards-content-weekly-row-1" className="sip-dashboards-content-row">
        <DashboardTile
          caption="SITE: Florida"
          duration="1W"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
        <DashboardTile
          caption="SITE: New York"
          duration="1W"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
      </div>
    );
    
    renderedControls.push(
      <div key="sip-dashboards-content-caption-weekly-2" className="sip-dashboards-content-caption">
        <span>Florida Media Weekly Totals</span>
      </div>
    );

    // Florida Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-weekly-row-2" className="sip-dashboards-content-row">            
        <DashboardTile
            caption="FLMedia1"
            duration="1W"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/weekly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"Florida"},{"NODE":"101"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="FLMedia2"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"102"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia3"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"103"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia4"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"104"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia5"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"105"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia6"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"106"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia7"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"107"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia8"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"108"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia9"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"109"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="1W"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"110"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>          
    );


    renderedControls.push(
      <div key="sip-dashboards-content-caption-weekly-3" className="sip-dashboards-content-caption">
        <span>New York Media Weekly Totals</span>
      </div>
    );

    // New York Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-weekly-row-3" className="sip-dashboards-content-row">
        <DashboardTile
            caption="NYMedia1"
            duration="1W"
            normal={161}
            warning={168}
            alert={336}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/weekly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"New York"},{"NODE":"201"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="NYMedia2"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"202"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia3"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"203"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia4"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"204"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia5"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"205"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia6"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"206"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia7"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"207"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia8"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"208"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia9"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"209"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia10"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"210"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia11"
          duration="1W"
          normal={161}
          warning={168}
          alert={336}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/weekly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"211"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>
    );

    return renderedControls;
  }

  onRenderRecognizerErrorsMonthlyDashboard( ) {
    const renderedControls = [];
    const category = this.state.category;
    const site_normal = this.SITE_DEFAULT_STATS[category].normal;
    const site_warning = this.SITE_DEFAULT_STATS[category].warning;
    const site_alert = this.SITE_DEFAULT_STATS[category].normal;
    const media_normal = this.MEDIA_DEFAULT_STATS[category].normal;
    const media_warning = this.MEDIA_DEFAULT_STATS[category].warning;
    const media_alert = this.MEDIA_DEFAULT_STATS[category].normal;


    renderedControls.push(
      <div key="sip-dashboards-content-caption-monthly-1" className="sip-dashboards-content-caption">
        <span>Sites Monthly Totals</span>
      </div>
    );

     // Florida/New York Sites
     renderedControls.push(
      <div key="sip-dashboards-content-monthly-row-1" className="sip-dashboards-content-row">
        <DashboardTile
          caption="SITE: Florida"
          duration="1M"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
        <DashboardTile
          caption="SITE: New York"
          duration="1M"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
      </div>
    );
    
    renderedControls.push(
      <div key="sip-dashboards-content-caption-monthly-2" className="sip-dashboards-content-caption">
        <span>Florida Media Monthly Totals</span>
      </div>
    );

    // Florida Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-monthly-row-2" className="sip-dashboards-content-row">            
        <DashboardTile
            caption="FLMedia1"
            duration="1M"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/monthly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"Florida"},{"NODE":"101"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="FLMedia2"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"102"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia3"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"103"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia4"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"104"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia5"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"105"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia6"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"106"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia7"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"107"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia8"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"108"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia9"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"109"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"110"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>          
    );


    renderedControls.push(
      <div key="sip-dashboards-content-caption-daily-3" className="sip-dashboards-content-caption">
        <span>New York Media Monthly Totals</span>
      </div>
    );

    // New York Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-monthly-row-3" className="sip-dashboards-content-row">
        <DashboardTile
            caption="NYMedia1"
            duration="1M"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/monthly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"New York"},{"NODE":"201"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="NYMedia2"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"202"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia3"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"203"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia4"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"204"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia5"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"205"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia6"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"206"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia7"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"207"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia8"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"208"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia9"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"209"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"210"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia11"
          duration="1M"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/monthly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"211"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>
    );

    return renderedControls;
  }

  onRenderRecognizerErrorsYearlyDashboard( ) {
    const renderedControls = [];
    const category = this.state.category;
    const site_normal = this.SITE_DEFAULT_STATS[category].normal;
    const site_warning = this.SITE_DEFAULT_STATS[category].warning;
    const site_alert = this.SITE_DEFAULT_STATS[category].normal;
    const media_normal = this.MEDIA_DEFAULT_STATS[category].normal;
    const media_warning = this.MEDIA_DEFAULT_STATS[category].warning;
    const media_alert = this.MEDIA_DEFAULT_STATS[category].normal;


    renderedControls.push(
      <div key="sip-dashboards-content-caption-yearly-1" className="sip-dashboards-content-caption">
        <span>Sites Yearly Totals</span>
      </div>
    );

     // Florida/New York Sites
     renderedControls.push(
      <div key="sip-dashboards-content-yearly-row-1" className="sip-dashboards-content-row">
        <DashboardTile
          caption="SITE: Florida"
          duration="1Y"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
        <DashboardTile
          caption="SITE: New York"
          duration="1Y"
          normal={site_normal}
          warning={site_warning}
          alert={site_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/sites/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />
      </div>
    );
    
    renderedControls.push(
      <div key="sip-dashboards-content-caption-yearly-2" className="sip-dashboards-content-caption">
        <span>Florida Media Yearly Totals</span>
      </div>
    );

    // Florida Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-yearly-row-2" className="sip-dashboards-content-row">            
        <DashboardTile
            caption="FLMedia1"
            duration="1Y"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/yearly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"Florida"},{"NODE":"101"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="FLMedia2"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"102"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia3"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"103"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia4"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"104"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia5"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"105"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia6"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"106"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia7"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"107"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia8"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"108"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia9"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"109"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="FLMedia10"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"110"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>          
    );


    renderedControls.push(
      <div key="sip-dashboards-content-caption-yearly-3" className="sip-dashboards-content-caption">
        <span>New York Media Yearly Totals</span>
      </div>
    );

    // New York Nodes
    renderedControls.push(
      <div key="sip-dashboards-content-yearly-row-3" className="sip-dashboards-content-row">
        <DashboardTile
            caption="NYMedia1"
            duration="1Y"
            normal={media_normal}
            warning={media_warning}
            alert={media_alert}
            dataType='number'
            route='dashboards/sip/recognizer/errors/nodes/yearly'
            mappedField='TOTAL_ERRORS'
            parameters={[{"SITE":"New York"},{"NODE":"201"}]}
            refreshEnabled={true}
            refreshDuration={30000}
          />
        <DashboardTile
          caption="NYMedia2"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"202"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia3"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"203"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia4"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"204"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia5"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"205"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia6"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"206"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia7"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"207"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia8"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"208"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia9"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"New York"},{"NODE":"209"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia10"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"210"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
        <DashboardTile
          caption="NYMedia11"
          duration="1Y"
          normal={media_normal}
          warning={media_warning}
          alert={media_alert}
          dataType='number'
          route='dashboards/sip/recognizer/errors/nodes/yearly'
          mappedField='TOTAL_ERRORS'
          parameters={[{"SITE":"Florida"},{"NODE":"211"}]}
          refreshEnabled={true}
          refreshDuration={30000}
        />                
      </div>
    );

    return renderedControls;
  }

  onRenderDefaultsPlayedDashboard( ) {
    return 'Defaults Played Dashboard';
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators','Operations']} >
        <div className="sip-dashboards">
          <div className="sip-dashboards-header">
            SIP Dashboards
          </div>
          <div className="sip-dashboards-filter">
            {this.onRenderFilters()}
          </div>
          <div className="sip-dashboards-content">
            {this.onRenderDashboards()}
          </div>
        </div>
      </PageAuthorize>        
    );
  }
};

export default SipDashboards; 


// WEBPACK FOOTER //
// ./src/content/dashboards/sip/components/SipDashboards.js